/** Module containing browser coordinate helper methods */

// TODO (05-10-2022):

/** Helper method to get selection from the element's root node */
function _getSelection(element) {
  const rootNode = element.getRootNode();
  return rootNode.getSelection();
}

/**
 * Gets the X and Y coordinates of a selection range
 *
 * @param {Element} element - HTML element to get selection from (defaults to `document`)
 * @param {boolean} atStart - whether to return coords from the start or end of the selection (defaults to `false`)
 * @returns {Object} x and y coordinates
 */
function getSelectionCoords(element = document, atStart = false) {
  const sel = _getSelection(element);

  // check if selection exists
  if (!sel.rangeCount) return null;

  // get range
  let range = sel.getRangeAt(0).cloneRange();
  if (!range.getClientRects) return null;

  // get client rect
  range.collapse(atStart);
  let rects = range.getClientRects();
  if (rects.length <= 0) return null;

  // return coord
  let rect = rects[0];
  return { x: rect.x, y: rect.y };
}

/**
 * Get the character offset of a selected range (or the caret position if equal)
 *
 * @param {Element} element - HTML element to get selection from (defualts to `document`)
 * @returns {Object} start and end char positions
 */
function getSelectionCharOffset(element = document) {
  const sel = _getSelection(element);

  if (sel.rangeCount == 0) return null;
  const range = sel.getRangeAt(0);

  let preCaretRange = range.cloneRange();
  preCaretRange.selectNodeContents(element);
  preCaretRange.setEnd(range.startContainer, range.startOffset);
  preCaretRange.setEnd(range.endContainer, range.endOffset);

  return {
    start: preCaretRange.toString().length,
    end: preCaretRange.toString().length
  };
}

function _getWordBounds(text, offset) {
  // Define helper function for identifying whitespace
  const isSpace = (c) => /\s/.exec(c);

  // Search for the word's beginning and end.
  let start = offset - 1;
  while (start >= 0 && !isSpace(text[start])) start -= 1;
  start = Math.max(0, start + 1);

  let end = offset;
  while (end < text.length && !isSpace(text[end])) end += 1;
  end = Math.max(start, end);

  return [start, end];
}

function getActiveWordBounds(element = document) {
  const offset = getSelectionCharOffset(element);
  if (!offset) return null;
  if (offset.start != offset.end) return null;
  // const start = offset.start;
  const text = element.innerText;

  return _getWordBounds(text, offset.start);
}

function getActiveWord(element = document) {
  const bounds = getActiveWordBounds(element);
  if (!bounds) return null;

  const text = element.innerText;
  return text.slice(...bounds);
}

function replaceActiveWord(element = document, replaceWithText, wrapWith = null, trailingSpace = false) {
  // const bounds = getActiveWordBounds(element);

  let selection = element.getRootNode().getSelection();
  const bounds = _getWordBounds(selection.anchorNode.textContent, selection.anchorOffset);
  if (!bounds) return;

  let replaceRange = document.createRange();
  replaceRange.setStart(selection.anchorNode, bounds[0]);
  replaceRange.setEnd(selection.anchorNode, bounds[1]);

  let replaceWithNode;
  if (wrapWith) {
    wrapWith.innerText = replaceWithText;
    replaceWithNode = wrapWith;
  } else replaceWithNode = document.createTextNode(replaceWithText);

  replaceRange.deleteContents();
  replaceRange.insertNode(replaceWithNode);

  if (trailingSpace) {
    replaceRange.collapse(false);
    replaceRange.insertNode(document.createTextNode(' '));
  }

  replaceRange.collapse(false);

  // Move the user's caret to the end of the word
  selection.removeAllRanges();
  selection.addRange(replaceRange);
}

export { getSelectionCoords, getSelectionCharOffset, getActiveWord, replaceActiveWord };
